export const environment = {
  local: false,
  production: true,
  testing: true,
  version: '2026.06.27',
  environmentName: 'testing',
  webUrl: 'https://beestesting.butterflydecisions.com/',
  apiUrl: 'https://beestesting.butterflydecisions.com/api/',
  loginUrl: 'https://beestesting.butterflydecisions.com/oauth/redirect',
  loginReturnUrl: 'https://testing.butterflydecisions.com/#/login',
  logoutUrl: 'https://beestesting.butterflydecisions.com/oauth/logout',
  logoutReturnUrl: 'https://testing.butterflydecisions.com/',

  checkInactivityTime: 180000,
  trackEventTime: 60000,

  passwordTimeoutDays: 120,

  googleMapsApiKey: 'AIzaSyCx3HmXsSlGRR6p_CZQVgEBLTIjn-P5grM',

  feedbackGloballyEnabled: true,
};
